export default __webpack_public_path__ + "static/media/snark-flights.4e670171.png";